import React, { useState } from "react"
import styled from "styled-components"
import { CopyToClipboard } from "react-copy-to-clipboard"

import NextImg from "@/common/components/NextImg"
import PanelButton from "./PanelButton"

export default function PanelShare({ roleID, resultImg, GetAndShare }) {
  const [copy1, setCopy1] = useState(false)
  const [copy2, setCopy2] = useState(false)
  const FBShare = () => {
    window.open(
      GetAndShare.shareURL + roleID,
      "popup",
      "location=0,width=750,height=650,left=500,top=55"
    )
    return false
  }

  return (
    <Wrapper>
      <TitleWrapper>分享給朋友</TitleWrapper>
      <h3>長按可以儲存圖片</h3>
      <CenterBlock>
        <ResultImgWrapper>
          <NextImg src={resultImg} />
        </ResultImgWrapper>
      </CenterBlock>
      <ButtonWrapper>
        <CopyToClipboard
          onCopy={() => {
            setCopy1(true)
            setTimeout(() => {
              setCopy1(false)
            }, 800)
          }}
          text={GetAndShare.coyyLink}
        >
          <PanelButton title="複製測驗連結" copy={copy1} />
        </CopyToClipboard>
        <PanelButton title={GetAndShare.shareText} onClick={FBShare} />
      </ButtonWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  min-width: 320px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  * {
    margin: 0;
  }
  h3 {
    font-size: 20px;
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;
    color: #00fff0;
  }
`
const TitleWrapper = styled.h1`
  color: #00fff0;
  font-size: 24px;
  text-shadow: 0 0 12px #00fff0;
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin: 12px 0 0;
  display: flex;
  gap: 12px;
`

const ResultImgWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 180%;
`

const CenterBlock = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow: auto;
  margin: 16px 0 0 0;
  border-radius: 12px 0 0 12px;
  border-radius: 4px;
  border: 1px solid #00fff0;
  padding-right: 4px;
`
// const Wrapper = styled.div``
// const Wrapper = styled.div``
